import React from "react";
import { Stack, Typography } from "@mui/material";

import { ProjectCards } from "src/widgets/ProjectCards";
import { RoutePaths } from "src/app/model";
import { AcceleratorCards } from "src/widgets/AcceleratorCards";

export const ProjectsPage: React.FC = () => {
  return (
    <Stack
      id={RoutePaths.PROJECTS}
      width={1}
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={1}
      sx={{
        scrollMarginTop: 80,
      }}
    >
      <Typography
        color="text.secondary"
        variant="h5"
        fontWeight="light"
        textTransform="uppercase"
        sx={{
          fontSize: { sm: "1.5rem", xs: "1rem" },
        }}
      >
        Projects
      </Typography>

      <Stack direction="row" gap={1} marginBottom={2}>
        <Typography
          color="text.secondary"
          variant="h4"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "2.125rem",
              md: "2rem",
              sm: "1.5rem",
              xs: "1.2rem",
            },
          }}
        >
          High-Impact
        </Typography>
        <Typography
          color="primary"
          variant="h4"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "2.125rem",
              md: "2rem",
              sm: "1.5rem",
              xs: "1.2rem",
            },
          }}
        >
          AI
        </Typography>
        <Typography
          color="text.secondary"
          variant="h4"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "2.125rem",
              md: "2rem",
              sm: "1.5rem",
              xs: "1.2rem",
            },
          }}
        >
          for Industry
        </Typography>
        <Typography
          color="primary"
          variant="h4"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "2.125rem",
              md: "2rem",
              sm: "1.5rem",
              xs: "1.2rem",
            },
          }}
        >
          Leaders
        </Typography>
      </Stack>

      <ProjectCards />

      <Stack direction="row" gap={1} marginTop={4}>
        <Typography
          color="text.secondary"
          variant="h4"
          textTransform="uppercase"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "2.125rem",
              md: "2rem",
              sm: "1.5rem",
              xs: "1.2rem",
            },
          }}
        >
          Deployable
        </Typography>
        <Typography
          color="primary"
          textTransform="uppercase"
          variant="h4"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "2.125rem",
              md: "2rem",
              sm: "1.5rem",
              xs: "1.2rem",
            },
          }}
        >
          AI Accelerators
        </Typography>
      </Stack>

      <Stack direction="row" gap={0.5} marginBottom={4}>
        <Typography
          variant="h5"
          color="text.secondary"
          fontWeight={300}
          sx={{
            fontSize: { sm: "1.5rem", xs: "1rem" },
          }}
        >
          Emphasizing
        </Typography>
        <Typography
          color="primary"
          variant="h5"
          fontWeight={300}
          sx={{
            fontSize: { sm: "1.5rem", xs: "1rem" },
          }}
        >
          Speed
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          fontWeight={300}
          sx={{
            fontSize: { sm: "1.5rem", xs: "1rem" },
          }}
        >
          &
        </Typography>
        <Typography
          color="primary"
          variant="h5"
          fontWeight={300}
          sx={{
            fontSize: { sm: "1.5rem", xs: "1rem" },
          }}
        >
          Acceleration
        </Typography>
      </Stack>

      <AcceleratorCards />
    </Stack>
  );
};
